import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../ReduxToolkit/Hooks';
import { useAuthModal } from '../contexts/AuthModalContext';

const PrivateRoute = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const { openAuthModal } = useAuthModal();

  React.useEffect(() => {
    if (!isAuthenticated) {
      openAuthModal();
    }
  }, []); // intentionally run only on mount

  if (!isAuthenticated) return <Navigate to="/" replace />;
  return <Outlet />;
};

export default PrivateRoute;
